import { render, staticRenderFns } from "./document-level-automations.vue?vue&type=template&id=1f657852"
import script from "./document-level-automations.vue?vue&type=script&lang=ts"
export * from "./document-level-automations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports